export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-[110px]">
      <div className="max-w-[1120px] mx-auto px-5 md:px-10">
        <h2 className="text-[24px] md:text-[30px] font-semibold text-[#1E2430] mb-[14px]">
          Start a Conversation
        </h2>
        <p className="text-[17px] leading-[1.65] text-[#5B6475] max-w-[620px] mb-10">
          We welcome confidential discussions with business owners, intermediaries, and investors. All inquiries are handled with discretion and professionalism.
        </p>
        <p className="text-[17px] text-[#1E2430]">
          Contact Steve Cagle at{' '}
          <a
            href="mailto:steven@valaxisgroup.com"
            className="text-[#2E3A59] font-medium hover:underline cursor-pointer"
          >
            steven@valaxisgroup.com
          </a>
        </p>
      </div>
    </section>
  );
}
